module.exports = __webpack_public_path__ + "img/obs_water_danger_down.94e81107.svg";